

module.exports = __webpack_require__.stylable.create(
    "Plan2589002058",
    {"classes":{"root":"Plan2589002058__root","plan":"Plan2589002058__plan","planTop":"Plan2589002058__planTop","currency":"Plan2589002058__currency","price":"Plan2589002058__price","duration":"Plan2589002058__duration","button":"Plan2589002058__button"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    9,
    "Plan2589002058",
    null
);
